import React, { createContext, useContext } from "react";
import { useSettings, type SiteSettings } from "@/hooks/useSettings";

interface SettingsContextType {
  settings: SiteSettings | undefined;
  isLoading: boolean;
  error: Error | null;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettingsContext must be used within a SettingsProvider");
  }
  return context;
};

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data: settings, isLoading, error } = useSettings();

  return (
    <SettingsContext.Provider value={{ settings, isLoading, error: error as Error | null }}>
      {children}
    </SettingsContext.Provider>
  );
};
